// extracted by mini-css-extract-plugin
export default {"MinhaContaWrapper":"MinhaConta_MinhaContaWrapper__RuCk0","MinhaContaSkeleton":"MinhaConta_MinhaContaSkeleton__ohoqU"};